module.exports = "https://cdn.hellotech.com/client-assets/ht_door_horizontal_logo_1e7139ba1c4f826d1d6b90e88e5fde17.svg";